import ProductDetailPage, {
  getServerSideProps as getServerSidePropsDetail,
} from '../[sku]';

export default ProductDetailPage;
export const getServerSideProps = getServerSidePropsDetail;
